import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';

import { SimpleCenteredModal } from '..';
import { showLeadQuotationRequest } from '../../requests/leadQuotations';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import ApproveQuotation from './ApproveQuotation';
import CloseQuotation from './CloseQuotation';

const SelectQuotation = ({
  canCloseQuotation,
  currentLeadQuotation,
  fromAdmin,
  indexPath,
  isSelected,
  lead,
  setMoreData,
  setSelectedFile,
  setSelectedQuotation
}) => {
  const [leadQuotation, setLeadQuotation] = useState(currentLeadQuotation);
  const [modalBody, setModalBody] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const dispatch = useDispatch();

  const { id, insuranceCompanyName, name, parsedCommissionPercentage, quotation } = leadQuotation;
  const quotationTitle = `[${insuranceCompanyName}] ${name}`;

  const handleModalClose = () => setModalShow(false);

  const handleShowLeadQuotationRequest = () => {
    setOnRequest(true);
    showLeadQuotationRequest(id, {
      dispatch,
      successCallback: response => setLeadQuotation(camelCaseEmptyStringRecursive(response.data)),
      callback: () => setOnRequest(false)
    });
  };

  const handleShowLeadQuotation = () => {
    handleShowLeadQuotationRequest();
    window.open(quotation?.fileUrl, '_blank', 'noopener');
  };

  return (
    <Row onClick={() => setSelectedQuotation(id)} className="quotation-select__container">
      <Col md={10} lg={3} className="align-self-end my-4 py-1 pr-lg-0">
        <p className={`list-element ${isSelected ? 'selected' : 'not-selected'}`}>{quotationTitle}</p>

        {canCloseQuotation && <p className="pl-5">(comisión póliza: {parsedCommissionPercentage})</p>}
      </Col>
      <Col md={2} lg={1} className="align-self-center mt-3">
        <Button variant="primary" className="btn-sm" onClick={handleShowLeadQuotation}>
          Ver
        </Button>
      </Col>

      {isSelected &&
        (canCloseQuotation ? (
          <CloseQuotation
            fromAdmin={fromAdmin}
            lead={lead}
            leadQuotation={leadQuotation}
            setLeadQuotation={setLeadQuotation}
            setSelectedFile={setSelectedFile}
            setModalBody={setModalBody}
            setModalShow={setModalShow}
            onRequest={onRequest}
            setOnRequest={setOnRequest}
            setMoreData={setMoreData}
          />
        ) : (
          <Col md={4} className="align-self-center mt-3">
            <ApproveQuotation
              lead={lead}
              leadQuotation={leadQuotation}
              quotationTitle={quotationTitle}
              indexPath={indexPath}
            />
          </Col>
        ))}

      <SimpleCenteredModal show={modalShow} body={modalBody} onHide={handleModalClose} />
    </Row>
  );
};

export default SelectQuotation;
